import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import AddProject from "./AddProject";
import CreateTask from "./CreateTask";
import ListHeader from "../../molecules/ListHeader/ListHeader";
import { setPage } from "../../redux/feature/AddProjectSlice";

const CreateProject = () => {
  const dispatch = useDispatch();
  const locationState = useLocation();

  const page = useSelector((state) => state.addProject.page);
  console.log('_page',page)
  const formData = useSelector((state) => state.addProject.formData);
  const { projectId, isEdit } = locationState.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  console.log("page", page);

  // Ensure correct step when entering edit mode
  useEffect(() => {
    if (isEdit && page !== 1) {
      dispatch(setPage(1));
    }
  }, [isEdit]);

  const renderPage = () => {
    switch (page) {
      case 1:
        return <AddProject />;
      case 2:
        return <CreateTask />;
      default:
        return <div></div>;
    }
  };

  return (
    <>
      <div className="min-h-screen bg-white md:p-20 p-4 main_container bg-cover bg-center">
        <ListHeader
          mainHeading="Project"
          placeholder="Search"
          btnShow={true}
          linkBreadCrum="/view-project"
          blinkBreadCrumText="Project"
          blinkBreadCrumText3={isEdit ? "Update Project" : "Add Project"}
          searchShow={false}
          showLikeFilter={false}
          DropDown={false}
        />

        <div className="mt-6">
          <div className={`grid grid-cols-2 w-full gap-4`}>
            {[1, 2]?.map((_, index) => (
              <div
                key={index}
                className={`h-[10px] rounded-[2px] ${
                  index < page ? "bg-[#1E3A8A]" : "bg-[#D9D9D9]"
                }`}
              />
            ))}
          </div>
        </div>

        {renderPage()}
      </div>
    </>
  );
};

export default CreateProject;
